export default {
  about: {
    hero: {
      eyebrow: 'Rreth nesh',
      title: 'Personal. Profesional. I saktë.',
      lead: '{{name}} përfaqëson mbikëqyrje me video të planifikuar individualisht dhe kujdes personal nga një burim i vetëm.',
    },
    story: {
      quote: '«Në vend që të shesim pako të gatshme, çdo pronë shqyrtohet sipas nevojave të saj reale – nga zonat e dëshiruara të imazhit te pikat e montimit, regjistrimi dhe konfigurimi i aplikacionit.»',
      p1: '{{name}} drejtohet nga {{owner}} – kontakti juaj personal nga konsultimi i parë te kujdesi i vazhdueshëm. Ai punon në teknologjinë e sigurisë prej më shumë se 20 vitesh dhe ka realizuar qindra projekte për privatë dhe biznese.',
      p2: 'Përvoja e gjatë mbulon planifikimin dhe instalimin e sistemeve të kamerave në shtëpi, pallate, dyqane, zyra, klinika, gastronomi, magazina, punishte dhe zona prodhimi. Çdo projekt shqyrtohet individualisht.',
      p3: 'Sipas kërkesave të projektit, {{name}} përdor ndër të tjera sisteme të sprovuara nga Hikvision dhe Safire. Mund të planifikohen edhe zgjidhje nga prodhues të tjerë.',
      p4: '{{name}} nuk e sheh veten si shitës i thjeshtë, por si partner afatgjatë. Pas instalimit mbetet kontakti personal.',
    },
    owner: {
      subtitle: 'Teknologji sigurie nga Hainburg',
      photoPlaceholder: 'Foto e pronarit së shpejti',
      role: 'Pronari dhe personi i kontaktit',
    },
    milestonesTitle: 'Përvojë që ndihet',
    milestones: {
      '0': { year: 'Mbi 20 vjet', desc: 'Përvojë në planifikimin dhe instalimin e sistemeve të kamerave për privatë dhe biznese në rajonin Rhein-Main.' },
      '1': { year: 'Qindra projekte të realizuara', desc: 'Nga shtëpitë te dyqanet dhe sistemet e mëdha: çdo projekt i planifikuar individualisht.' },
      '2': { year: 'I pavarur nga prodhuesit', desc: 'Zgjedhim teknologjinë e duhur për kërkesat tuaja, nga prodhues të ndryshëm të njohur.' },
    },
    valuesTitle: 'Çfarë e bën {{name}} të veçantë',
    values: {
      '0': { title: 'Planifikim individual', desc: 'Pa pako të gatshme. Çdo pronë shqyrtohet sipas nevojës reale.' },
      '1': { title: 'Zbatim profesional', desc: 'Instalim i pastër, orientim i saktë dhe kabllim profesional.' },
      '2': { title: 'Lidhje dixhitale', desc: 'Aplikacion, qasje në distancë dhe njoftime – të konfiguruara dhe shpjeguara.' },
      '3': { title: 'Kujdes personal', desc: 'Një person kontakti. I besuar. I besueshëm. Edhe pas instalimit.' },
    },
    cta: {
      title: 'Na njihni',
      lead: 'Një bisedë e parë jo-detyruese tregon shpejt nëse jemi të përshtatshëm. Me kënaqësi presim të njohim projektin tuaj.',
      primary: 'Rezervoni një takim',
      secondary: 'Pyetje të shpeshta',
    },
  },
};